const API_LIST = [
  'AIzaSyAM9R1vr9t6GSrazqGtw5t8RBKmz2Q17dk',
  'AIzaSyCvaktMcshCgWbahXn7JuJcmhUlSR5ZxAA',
  'AIzaSyBboFo9umdEW03mwz8IdLsRVWXEeAyokdw',

  'AIzaSyAmw-1dYBqj1MIqccmtfeLWfgzYqROkylY',
  
];


const randomIndex = Math.floor(Math.random() * API_LIST.length);


const API_KEY = API_LIST[randomIndex];
let Array = [
  'government exam preparation',
  'guided meditation',
  'programming tutorials for beginners',
  'software development podcasts',
  'best motivational videos',
  'Swami Vivekananda quotes on success',
  'mental health and mindfulness',
  'Buddhism and self-improvement',
  'career guidance for students',
  'technology trends and innovations',
  'success stories of entrepreneurs',
  'study tips for exams'
];

const randomTopic = Math.floor(Math.random() * Array.length);
let searchQuery = Array[randomTopic];

export const fetchData = async () => {
    const apiUrl = `https://www.googleapis.com/youtube/v3/search?part=snippet&type=video&maxResults=18&q=${searchQuery}&videoDuration=long&key=${API_KEY}`;


  try {
    const response = await fetch(apiUrl);
    const data = await response.json();
   
    return data;
    
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; // Re-throw the error to handle it elsewhere
  }
};
window.addEventListener('load', fetchData);
